var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "calendar" } }, [
    _c(
      "div",
      { staticClass: "route-page-content breadcrumb-content" },
      [
        _c("SidebarChild", {
          attrs: {
            items: _vm.menuItems,
            "selected-item": _vm.currentPage,
            focusActive: true,
            className: "calendar-menu",
          },
          on: { selected: _vm.fnClicked, clicked: _vm.fnClicked },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _vm.currentPage === "automations"
              ? _c("AutomationList", {
                  attrs: { type: "event", module: "calendar" },
                })
              : _c(
                  "a-spin",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { spinning: _vm.loading },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "fit-content",
                          "margin-top": "55px",
                        },
                      },
                      [
                        _c("vc-date-picker", {
                          attrs: { color: "red" },
                          model: {
                            value: _vm.dateRange,
                            callback: function ($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange",
                          },
                        }),
                        _vm._v(" "),
                        _c("CalendarList", {
                          attrs: {
                            calendarList: _vm.calendarList,
                            selectedCalendars: _vm.selectedCalendars,
                          },
                          on: {
                            selectCalendar: _vm.selectCalendar,
                            updateCalendarColor: _vm.updateCalendarColor,
                            deleteCalendarEvents: _vm.deleteCalendarEvents,
                          },
                        }),
                        _vm._v(" "),
                        _c("ReservationList"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("FullCalendar", {
                          ref: "calendar",
                          attrs: { options: _vm.calendarOptions },
                        }),
                        _vm._v(" "),
                        _vm.$route.params.type === "l"
                          ? _c("CalendarEventListview", {
                              staticStyle: { "margin-top": "10px" },
                              attrs: {
                                events: _vm.events,
                                "group-by-date": true,
                                calendarList: _vm.calendarList,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.newEventModalVisible
                      ? _c("CreateEventModal", {
                          attrs: {
                            eventDetail: _vm.eventDetail,
                            selectedStartDate:
                              _vm.selectedStartDate === ""
                                ? new Date()
                                : _vm.selectedStartDate,
                            selectedEndDate:
                              _vm.selectedEndDate === ""
                                ? new Date()
                                : _vm.selectedEndDate,
                            calendarList: _vm.calendarList,
                          },
                          on: {
                            close: function ($event) {
                              _vm.newEventModalVisible = false
                            },
                            deleteEvent: function ($event) {
                              return _vm.deleteEventFunction($event)
                            },
                            editEvent: function ($event) {
                              return _vm.editEvent($event)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }